import { InternationalMember } from "types";

export const getMemberPreferredName = (member?: InternationalMember) => {
  if (!member) {
    return "";
  }
  return member.preferredName ? member.preferredName : member.firstName;
};
